import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconLinkedin(props: IconProps & { invert?: boolean }) {
  return (
    <BaseIcon {...props}>
      <path
        d="M22.228 0H1.773C.793 0 0 .77 0 1.72v20.56C0 23.23.794 24 1.773 24h20.455c.979 0 1.772-.77 1.772-1.72V1.72C24 .77 23.207 0 22.228 0ZM7.5 20.25H3.75V9H7.5v11.25ZM5.615 7.5h-.022c-1.118 0-1.843-.833-1.843-1.876 0-1.064.746-1.874 1.886-1.874s1.842.81 1.864 1.874C7.5 6.667 6.777 7.5 5.615 7.5ZM20.25 20.25h-3.685v-5.88c0-1.478-.534-2.487-1.867-2.487-1.02 0-1.625.68-1.89 1.337-.099.235-.123.563-.123.89v6.14H9s.048-9.96 0-10.991h3.685v1.558C13.175 10.068 14.05 9 16.005 9c2.426 0 4.245 1.57 4.245 4.948v6.302Zm-7.367-9.414a.731.731 0 0 1 .032-.046v.046h-.032Z"
        fill={props.invert ? '#fff' : '#488AE9'}
      />
    </BaseIcon>
  );
}
